import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DigiServiceService {

  constructor(private http: HttpClient) { }

  getDigiParameters() {
      return this.http.get('getDigiParameters');
  }
  addGenerator(data:any): Observable<any>{
    return this.http.post('addDigiManager',data);
  }
  UpdateGenerator(data:any): Observable<any>{
    return this.http.post('updateDigiManager',data);
  }
  getGenerators(): Observable<any> {
    return this.http.get(`getGenetors`);
  }
  deleteGenerators(data:any): Observable<any> {
    return this.http.post(`deleteGenetors`,data);
  }
  getDigiIds(data:any): Observable<any> {
    return this.http.post(`getGenetorsId`,data);
  }
  getDigiLastData(data:any): Observable<any> {
    return this.http.post(`getDigiLastData`,data);
  }
  getReportData(data:any): Observable<any> {
    return this.http.post(`getReportData`,data);
  }
  getGeneratorByDeviceid(data:any): Observable<any> {
    return this.http.post(`getGeneratorByDeviceid`,data);
  }
  getAlerts(data:any): Observable<any> {
    return this.http.post(`getAlertsByDeviceId`,data);
  }
  getDeviceStatus(data:any): Observable<any> {
    return this.http.post(`getDeviceStatus`,data);
  }
  
}
